(function() {
  window.SideCart = window.SideCart || new function() {
    //runs once per page load
    var self = this;
    var isOpen = false;
    
    document.addEventListener('click', function(event){
      var sideCart = document.getElementById('side-cart');
      if(!sideCart || (!event.target.closest('#side-cart') && event.target.id!="loading-overlay" && sideCart.classList.contains('open'))) {
        self.hideSideCart();
      }
    });

    self.isOpen = function() {
      return isOpen;
    }

    self.updateSideCart = function(open) {
      $s.showLoadingOverlay();
      $s.getJson({url: '/?sections=side_cart', success: function(data){
        var section = document.getElementById('shopify-section-side_cart');
        if (section) {
          section.parentNode.removeChild(section);
          document.body.insertAdjacentHTML("beforeend", data["side_cart"]);
        }
        if (open) {
          self.showSideCart(!isOpen);
        }
        $s.hideLoadingOverlay();
        self.openAfterUpdate = open;
        $s.globalEval(data["side_cart"]);
      }});
    }

    self.showSideCart = function(animate) {
      $s.closeModal();

      isOpen = true;
      var sideCart = document.getElementById('side-cart');
      $s.showOverlay()
      if(animate) {
        setTimeout(function(){sideCart.classList.add('open')}, 100);
      } else {
        sideCart.classList.remove('ease-animation-slow');
        sideCart.classList.add('open');
        setTimeout(function(){sideCart.classList.add('ease-animation-slow')}, 200);
      }
      $s.trapFocus(sideCart);
    };

    self.hideSideCart = function() {
      isOpen = false;
      var sideCart = document.getElementById('side-cart');
      $s.hideOverlay();
      sideCart.classList.remove('open');
      $s.removeTrapFocus();
    };

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: async function(cart) {
          var runResponse = await $s.AutoAddRemoveProducts.runAllRules(JSON.parse(cart), true);
          $s.addToCartSuccess();
        },
        error: $s.addToCartFail
      });
    }

    window.addEventListener('keydown', function(e){
      if (e.which == 27) { //Exit
        var sideCart = document.getElementById('side-cart');
        if(sideCart.classList.contains('open')){
          e.preventDefault();
          window.SideCart.hideSideCart();
          return false;
        }
      }
    });
  
  };


  //runs every time #side-cart div is replaced
  var sideCart = document.getElementById('side-cart');
  var itemsCount = 0;
  sideCart.querySelectorAll('.cart-items .quantity-box input[type=number]').forEach(function(item){
    itemsCount += item.value/1;
  });
  var cartCountElement = document.querySelector('header .cart-count');
  cartCountElement.innerHTML = itemsCount>0?itemsCount:0;

  sideCart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      SideCart.updateItemsQuantity([this.closest('.item')], 0);
    });
  });

  sideCart.querySelectorAll('.cart-items input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      SideCart.updateItemsQuantity([this.closest('.item')], this.value);
    });
  });

  sideCart.querySelector('#side-cart .head .close').addEventListener('click', function (e) {
    window.SideCart.hideSideCart();
  });


        
  var checkInstructions = document.getElementById('sidecart-chk-instructions');
  if (checkInstructions) {
    var checkInstructionsChange = function() {
      var note = document.getElementById('sidecart-instructions-note');
      if (checkInstructions.checked) {
        note.style.display = 'block';
      } else {
        note.style.display = 'none';
        var textarea = note.querySelector('textarea');
        if (textarea.value != '') {
          textarea.value = '';
          $s.dispatchEvent(textarea, 'change');
        }
      }
    }
    checkInstructions.labels[0].addEventListener('keypress', function(event) {
      if (event.keyCode==13) {
        checkInstructions.click();
      }
    });
    checkInstructions.addEventListener('click', checkInstructionsChange);
    checkInstructionsChange();
  }
  

  

})();